import { Items, OrderItems } from '@prisma/client';
import { Transaction } from '../../interfaces';
import { OrderWithPayments } from '../../types/orders';
import { convertPaymentsToTransactions } from '../payments';

export function getOrderItemName(
  item: Pick<OrderItems, 'customItemName'> & {
    item?: Pick<Items, 'name'> | null;
  },
) {
  return item.item?.name || item.customItemName || '';
}

export function getOrderCashTransaction(
  order: OrderWithPayments | null,
): Transaction[] {
  const transactions: Transaction[] = [];
  if (order && order.paymentMethod === 'CASH' && order.status === 'COMPLETED') {
    const cashTransactions = order.payments.filter(
      payment => payment.method === 'CASH',
    );
    if (cashTransactions.length) {
      const tx = convertPaymentsToTransactions(order.payments, {
        order,
      });
      transactions.push(...tx);
    } else {
      const tx: Transaction = {
        id: order.orderId,
        amount: order.totalPrice,
        dateCreated: new Date(order.createdAt),
        dateUpdated: new Date(order.createdAt),
        status: 'SUCCESS',
        type: 'CASH',
        order,
      };
      transactions.push(tx);
    }
  }

  return transactions;
}
